import React from 'react';
import { VideoContainer } from './style.css'
import eye from '../../assets/watch.svg'

const VideoGallery = () => {
    return (
        <VideoContainer
            data-sal="slide-up"
            data-sal-delay="2000"
            data-sal-easing="ease">
            <div>
                <div className="time">
                    <img src={eye} alt="ojo" />
                    <p>4:57</p>
                </div>
                <iframe
                    id="vrudo"
                    className="vrudo"
                    src="https://www.youtube.com/embed/OeVnFkXOplk"
                    allowscriptaccess="always"
                    allowFullScreen={true}
                    webkitallowfullscreen="true"
                    frameBorder="0"
                    scrolling="no"
                    allow="autoplay"
                />
                <p>01. Arriba y abajo de la tabla.</p>
            </div>
            <div>
                <div className="time">
                    <img src={eye} alt="ojo" />
                    <p>4:21</p>
                </div>
                <iframe
                    id="vrudo"
                    className="vrudo"
                    src="https://www.youtube.com/embed/FD5ATzB_jmg"
                    allowscriptaccess="always"
                    allowFullScreen={true}
                    webkitallowfullscreen="true"
                    frameBorder="0"
                    scrolling="no"
                    allow="autoplay"
                />
                <p>02. La Crew.</p>
            </div>
            <div>
                <div className="time">
                    <img src={eye} alt="ojo" />
                    <p>4:26</p>
                </div>
                <iframe
                    id="vrudo"
                    className="vrudo"
                    src="https://www.youtube.com/embed/VOPwo6H4Mrk"
                    allowscriptaccess="always"
                    allowFullScreen={true}
                    webkitallowfullscreen="true"
                    frameBorder="0"
                    scrolling="no"
                    allow="autoplay"
                />
                <p>03. Unidas 360°.</p>
            </div>
        </VideoContainer>
    );
}

export default VideoGallery;